import './index.css';
import Modal from 'components/Modal';
import { useState } from 'react';
import ProdutoService from '../../services/produtos.service';
// import { toast } from 'react-hot-toast';


const ProdutoDetailsModal = ({ getList, produto, closeModal }) => {
	const [editionMode, setEditionMode] = useState(false);

	const [nome, setProduto] = useState(produto.produto);
	const [preco, setPreco] = useState(produto.preco);
	const [descricao, setDescricao] = useState(produto.descricao);
	const [foto, setFoto] = useState(produto.foto);

	const handleEditProduto = async () => {
		const produtoEditado = {
			produto: nome,
			preco,
			descricao,
			foto,
		};
		const res = await ProdutoService.updateById(produto._id, produtoEditado);
		closeModal();
		getList();
	};
	const handleDeleteProduto = async () => {
		const res = await ProdutoService.deleteById(produto._id);
		closeModal();
		getList();
	};

	return (
		<Modal closeModal={closeModal}>
			<div className='ProdutoDetalhesModal'>
				<div>
					{!editionMode && <div className='ProdutoDetalhesModal__titulo'> {produto.produto} </div>}
					{editionMode && <input type='text' value={nome} placeholder='Nome do produto' onChange={(e) => setProduto(e.target.value)} name='produto' />}
					{!editionMode && <div className='ProdutoDetalhesModal__preco'> R$ {Number(produto.preco).toFixed(2)}</div>}
					{editionMode && <input type='number' min='1' value={preco} placeholder='Preço do produto' onChange={(e) => setPreco(e.target.value)} name='preco' />}
					{!editionMode && (
						<div className='ProdutoDetalhesModal__descricao'>
							<b>Descrição:</b> {produto.descricao}
						</div>
					)}
					{editionMode && <input type='text' value={descricao} placeholder='Descrição do produto' onChange={(e) => setDescricao(e.target.value)} name='preco' />}
					{editionMode && <input type='text' value={foto} placeholder='Caminho de imagem' onChange={(e) => setFoto(e.target.value)} name='image' />}
				</div>
				<div className='ProdutoDetalhesModal__Btns'>
					<span
						className='ProdutoDetalhesModal__editFancy'
						onClick={(e) => {
							e.stopPropagation();
							setEditionMode(!editionMode);
						}}
					>
						{!editionMode ? '📝' : '🔙'}
					</span>
					{editionMode && (
						<span
							className='ProdutoDetalhesModal__editFancy'
							onClick={(e) => {
								e.stopPropagation();
								handleEditProduto();
								setEditionMode(!editionMode);
							}}
						>
							✔️
						</span>
					)}
					{editionMode && (
						<span
							className='ProdutoDetalhesModal__editFancy'
							onClick={(e) => {
								e.stopPropagation();
								handleDeleteProduto();
								setEditionMode(!editionMode);
							}}
						>
							🗑
						</span>
					)}
				</div>

				{/* <img className='ProdutoDetalhesModal__foto' src={produto.foto} alt={`Foto de ${produto.produto}`} /> */}
			</div>
		</Modal>
	);
};

export default ProdutoDetailsModal;
